import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/layout/PageHero";
import { Reveal } from "@/components/motion/Reveal";
import { CtaBand } from "@/components/layout/CtaBand";
import { IMAGES, WHY_SECTIONS } from "@/data/content";

export default function WhyMeridian() {
  useSeo({
    title: "Why Meridian",
    description:
      "Responsive communication, a reliable vendor network, competitive sourcing, contract compliance, and veteran leadership — the reasons agencies choose Meridian Vanguard Solutions.",
    path: "/why-meridian",
    breadcrumb: [{ name: "Home", path: "/" }, { name: "Why Meridian", path: "/why-meridian" }],
  });

  return (
    <>
      <PageHero
        eyebrow="Our Difference"
        titleLines={["Why Meridian"]}
        subtitle="A structured, principled approach to procurement — built on reliability, compliance, and long-term partnership."
        image={IMAGES.dashboard}
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Why Meridian", path: "/why-meridian" }]}
      />

      <section className="bg-white">
        <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
          {WHY_SECTIONS.map((s, i) => (
            <Reveal key={s.n}>
              <div
                data-testid={`why-section-${s.n}`}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-start py-14 md:py-20 ${
                  i !== WHY_SECTIONS.length - 1 ? "border-b border-hairline" : ""
                }`}
              >
                <div className="lg:col-span-4">
                  <span className="font-heading font-extrabold text-[5rem] md:text-[7rem] leading-none text-navy/[0.08] select-none">
                    {s.n}
                  </span>
                </div>
                <div className="lg:col-span-8 lg:pt-6">
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy tracking-tight">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-steel leading-relaxed text-lg max-w-3xl">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand
        title="Experience a dependable procurement partner"
        text="Connect with Meridian Vanguard Solutions to learn how our disciplined, mission-focused approach can support your agency or supplier organization."
      />
    </>
  );
}
